import PropTypes from 'prop-types';
import React from 'react';
import { fullName } from '../../helpers/users';

const BarberOption = ({ barber, updateBarbersViewed, checked }) => (
  <div className="c-filter-dropdown-checkbox">
    <input
      className="c-filter-dropdown-checkbox__input"
      type="checkbox"
      checked={checked}
      id={barber.id}
      onChange={e => updateBarbersViewed(e.target.checked, barber)}
      value="true"
    />

    <label className="c-filter-dropdown-checkbox__label" htmlFor={barber.id}>
      <span className="c-filter-dropdown-checkbox__trigger" />
      <span className="c-filter-dropdown-checkbox__text" data-automation-id={`filter:barbers:${barber.id}`}>
        {fullName(barber)}
      </span>
    </label>
  </div>
);

BarberOption.propTypes = {
  updateBarbersViewed: PropTypes.func.isRequired,
  barber: PropTypes.object,
  checked: PropTypes.bool,
};

export default BarberOption;
